
/**
 * Module dependencies.
 */

import { useImageSizeResolver } from './image-size-resolver';

/**
 * Export `ImageSources` type.
 */

export type ImageSources = {
  defaultUrl: string | null | undefined;
  retinaUrl: string | null | undefined;
};

/**
 * Export `LocalImageSources` type.
 */

export type LocalImageSources = {
  defaultUrl: string;
  retinaUrl: string;
};

/**
 * Export `useImageSources`.
 */

export function useImageSources(imageUrl: string | null | undefined, size: string): ImageSources | null {
  const resolveSize = useImageSizeResolver();
  const [imageSize] = size.split('x');

  if (!imageUrl) {
    return null;
  }

  return {
    defaultUrl: resolveSize(imageUrl, size),
    retinaUrl: resolveSize(imageUrl, `${Number(imageSize) * 2}x`)
  };
}
